import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import ImportLeads from "@/pages/ImportLeads";
import TeamMembers from "@/pages/TeamMembers";
import ServiceCategoriesPage from "@/pages/ServiceCategoriesPage";
import Tasks from "@/pages/Tasks";
import Reports from "@/pages/Reports";
import PartnershipsPage from "@/pages/PartnershipsPage";
import PartnershipPipeline from "@/pages/PartnershipPipeline";
import ClientsPage from "@/pages/ClientsPage";
import SettingsPage from "@/pages/SettingsPage";
import GoalsAdmin from "@/pages/GoalsAdmin";
import PipelineReport from "@/pages/PipelineReport";
import CampaignsPage from "@/pages/CampaignsPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors offset={80} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/opportunities/:id" element={<OpportunityDetail />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/import" element={<ProtectedRoute allowedRoles={["admin"]}><ImportLeads /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute allowedRoles={["admin"]}><TeamMembers /></ProtectedRoute>} />
            <Route path="/goals" element={<ProtectedRoute allowedRoles={["admin"]}><GoalsAdmin /></ProtectedRoute>} />
            <Route path="/pipeline-report" element={<ProtectedRoute><PipelineReport /></ProtectedRoute>} />
            <Route path="/campaigns" element={<ProtectedRoute allowedRoles={["admin"]}><CampaignsPage /></ProtectedRoute>} />
            <Route path="/services" element={<ProtectedRoute allowedRoles={["admin"]}><ServiceCategoriesPage /></ProtectedRoute>} />
            <Route path="/partnerships" element={<ProtectedRoute allowedRoles={["admin"]}><PartnershipsPage /></ProtectedRoute>} />
            <Route path="/partnership-pipeline" element={<ProtectedRoute><PartnershipPipeline /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute allowedRoles={["admin", "full_access"]}><ClientsPage /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute allowedRoles={["admin", "full_access"]}><Reports /></ProtectedRoute>} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
